// extracted by mini-css-extract-plugin
export default {"wrapper":"full-ui_wrapper__gwR92","topBar":"full-ui_topBar__q7jwA","mainColumn":"full-ui_mainColumn__dDPUT"};